export const tabIndex = (focusable = true) => (focusable ? 0 : -1);



// WEBPACK FOOTER //
// ./helpers/accessibility.js